import { printHtmlNodesToText } from '@utils/ast';
import { UniversalErrorCard } from '@utils/component-framework';
import { jsx } from 'react/jsx-runtime';

const componentFrameworkErrorJsxPrinters = {
  "component-framework.error": () => {
    return /*#__PURE__*/jsx(UniversalErrorCard, {});
  }
};
const componentFrameworkErrorTextPrinters = {
  "component-framework.error": node => {
    return printHtmlNodesToText(node.meta.richTextDescription);
  }
};
const componentFrameworkErrorPaperPrinters = {
  "component-framework.error": () => {
    return [{
      content: /*#__PURE__*/jsx(UniversalErrorCard, {})
    }];
  }
};

export { componentFrameworkErrorJsxPrinters, componentFrameworkErrorPaperPrinters, componentFrameworkErrorTextPrinters };
//# sourceMappingURL=message.component-framework-error.js.map
